import { Page } from "@tfg/ui"
import { useTranslation } from "react-i18next"

export const SupplierProductionSitesWrapper = () => {
  const { t } = useTranslation(["supplier"])

  return <Page title={t("productionSites.title")} />
}
